"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialLoginType = exports.UserStatus = exports.Role = void 0;
var Role;
(function (Role) {
    Role["SUPER_ADMIN"] = "SUPER_ADMIN";
    Role["ADMIN"] = "ADMIN";
    Role["DEBUGGER"] = "DEBUGGER";
    Role["USER"] = "USER";
    Role["CUSTOMER_SUCCESS"] = "CUSTOMER_SUCCESS";
    Role["SCOUT"] = "SCOUT";
})(Role = exports.Role || (exports.Role = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["ARCHIVED"] = "ARCHIVED";
    UserStatus["EXPIRED"] = "EXPIRED";
    UserStatus["BANNED"] = "BANNED";
    UserStatus["UNDER_PROCESSING"] = "UNDER_PROCESSING";
    UserStatus["REJECTED"] = "REJECTED";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
var SocialLoginType;
(function (SocialLoginType) {
    SocialLoginType["GOOGLE"] = "GOOGLE";
    SocialLoginType["MICROSOFT"] = "MICROSOFT";
    SocialLoginType["SSO"] = "SSO";
})(SocialLoginType = exports.SocialLoginType || (exports.SocialLoginType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci1lbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3VzZXIvdHlwZXMvdXNlci1lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVksSUFPWDtBQVBELFdBQVksSUFBSTtJQUNkLG1DQUEyQixDQUFBO0lBQzNCLHVCQUFlLENBQUE7SUFDZiw2QkFBcUIsQ0FBQTtJQUNyQixxQkFBYSxDQUFBO0lBQ2IsNkNBQXFDLENBQUE7SUFDckMsdUJBQWUsQ0FBQTtBQUNqQixDQUFDLEVBUFcsSUFBSSxHQUFKLFlBQUksS0FBSixZQUFJLFFBT2Y7QUFFRCxJQUFZLFVBT1g7QUFQRCxXQUFZLFVBQVU7SUFDcEIsK0JBQWlCLENBQUE7SUFDakIsbUNBQXFCLENBQUE7SUFDckIsaUNBQW1CLENBQUE7SUFDbkIsK0JBQWlCLENBQUE7SUFDakIsbURBQXFDLENBQUE7SUFDckMsbUNBQXFCLENBQUE7QUFDdkIsQ0FBQyxFQVBXLFVBQVUsR0FBVixrQkFBVSxLQUFWLGtCQUFVLFFBT3JCO0FBRUQsSUFBWSxlQUlYO0FBSkQsV0FBWSxlQUFlO0lBQ3pCLG9DQUFpQixDQUFBO0lBQ2pCLDBDQUF1QixDQUFBO0lBQ3ZCLDhCQUFXLENBQUE7QUFDYixDQUFDLEVBSlcsZUFBZSxHQUFmLHVCQUFlLEtBQWYsdUJBQWUsUUFJMUIifQ==